import { InsuranceCoverageMonitorSettings } from "../../../../../services/api/insurance/monitor/types";
import { IPolicyType } from "../../../../../services/api/insurance/coverage/types";
import intersection from "lodash/intersection";
import { selectorPolicyTypesFromSettings } from "./selectorPolicyTypesFromSettings";

export const selectorIsPolicyTypesMatched = (
  insuranceCoverageMonitorSettings?: InsuranceCoverageMonitorSettings,
  policyTypes?: IPolicyType[]
) => {
  const settingsTypes = selectorPolicyTypesFromSettings(
    insuranceCoverageMonitorSettings
  );

  return intersection(settingsTypes, policyTypes).length > 0;
};
